import React from 'react';
import Dialog from 'react-native-dialog';
import { View } from 'react-native';
import { popUpDefaultProps, popUpPropTypes } from '../../propTypes';

const PopUpNative = ({ visible, title, confirmLabel, onConfirm }) => (
    <View>
        <Dialog.Container visible={visible}>
            <Dialog.Title>{title}</Dialog.Title>
            <Dialog.Button label={confirmLabel} onPress={onConfirm} />
        </Dialog.Container>
    </View>
);

PopUpNative.defaultProps = popUpDefaultProps;

PopUpNative.propTypes = popUpPropTypes;

export default PopUpNative;
